import { render, staticRenderFns } from "./RptPendientes.vue?vue&type=template&id=971f9b3a&"
import script from "./RptPendientes.vue?vue&type=script&lang=js&"
export * from "./RptPendientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports